/**
 * Cart consent label "Show more / Show less" toggle.
 * Targets the long T&C label injected by the Effective Apps "TnC Terms Checkbox" Shopify app.
 * Loaded only on the cart template (gated in layout/theme.liquid).
 */
(function () {
  'use strict';

  var CHAR_LIMIT = 100;
  var WATCH_DURATION_MS = 20000;
  var processed = false;

  function pickTargetElement(labelElement) {
    var directText = Array.prototype.filter
      .call(labelElement.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE;
      })
      .map(function (node) {
        return node.textContent.trim();
      })
      .join(' ');

    if (directText.length > CHAR_LIMIT) {
      return { element: labelElement, text: directText };
    }

    var spans = labelElement.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var text = spans[i].textContent.trim();
      if (text.length > CHAR_LIMIT) {
        return { element: spans[i], text: text };
      }
    }

    return null;
  }

  function applyShowMore(labelElement) {
    if (processed || labelElement.dataset.showMoreProcessed === 'true') return;

    var target = pickTargetElement(labelElement);
    if (!target) return;

    processed = true;
    labelElement.dataset.showMoreProcessed = 'true';

    var truncated = target.text.substring(0, CHAR_LIMIT) + '...';

    var container = document.createElement('span');
    container.style.display = 'inline';

    var textSpan = document.createElement('span');
    textSpan.textContent = truncated;

    var toggleButton = document.createElement('button');
    toggleButton.type = 'button';
    toggleButton.className = 'cart-consent__toggle';
    toggleButton.style.cssText =
      'color:#0066cc;text-decoration:underline;margin-left:5px;cursor:pointer;' +
      'font:inherit;background:none;border:0;padding:0;';
    toggleButton.textContent = 'Show more';

    if (target.element === labelElement) {
      var checkbox = labelElement.querySelector('input[type="checkbox"]');
      labelElement.innerHTML = '';
      if (checkbox) labelElement.appendChild(checkbox);
      labelElement.appendChild(container);
    } else {
      target.element.innerHTML = '';
      target.element.appendChild(container);
    }

    container.appendChild(textSpan);
    container.appendChild(toggleButton);

    var expanded = false;
    toggleButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      expanded = !expanded;
      textSpan.textContent = expanded ? target.text + ' ' : truncated;
      toggleButton.textContent = expanded ? 'Show less' : 'Show more';
    });
  }

  function findLabel() {
    var selectors = [
      'label[for="effectiveAppsAgreeCB"]',
      'label[for*="agree"]',
      '#effectiveAppsAgreeCB + label',
      '.consent-checkbox label',
      '.agreement-checkbox label'
    ];

    for (var i = 0; i < selectors.length; i++) {
      try {
        var label = document.querySelector(selectors[i]);
        if (label) return label;
      } catch (e) {
        /* selector unsupported in current browser */
      }
    }

    var input = document.getElementById('effectiveAppsAgreeCB');
    if (input) {
      return (
        input.closest('label') ||
        (input.parentElement && input.parentElement.querySelector('label')) ||
        null
      );
    }

    return null;
  }

  function tryApply() {
    var label = findLabel();
    if (label) {
      applyShowMore(label);
      return processed;
    }
    return false;
  }

  function init() {
    if (tryApply()) return;

    var observer = new MutationObserver(function () {
      if (tryApply()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, WATCH_DURATION_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
